var _mask, _path, _path2, _path3, _mask2, _path4, _path5, _rect, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturedArtists(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.784 16.0303C25.9686 16.5528 25.504 17.0158 24.9499 17.0158H20.9591C20.405 17.0158 19.9404 16.5528 20.125 16.0303C20.5367 14.8649 21.6481 14.0298 22.9545 14.0298C24.2609 14.0298 25.3723 14.8649 25.784 16.0303Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.784 16.0303C25.9686 16.5528 25.504 17.0158 24.9499 17.0158H20.9591C20.405 17.0158 19.9404 16.5528 20.125 16.0303C20.5367 14.8649 21.6481 14.0298 22.9545 14.0298C24.2609 14.0298 25.3723 14.8649 25.784 16.0303Z",
    fill: "#404040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.784 16.0303L22.9553 17.0295L25.784 16.0303ZM20.9591 20.0158H24.9499V14.0158H20.9591V20.0158ZM22.9537 17.0295L22.9545 17.0298V11.0298C20.337 11.0298 18.1182 12.7042 17.2963 15.0311L22.9537 17.0295ZM22.9545 17.0298L22.9553 17.0295L28.6127 15.0312C27.7908 12.7042 25.572 11.0298 22.9545 11.0298V17.0298ZM24.9499 20.0158C26.0363 20.0158 27.118 19.5688 27.8776 18.7217C28.6918 17.8135 29.1087 16.4352 28.6127 15.0312L22.9553 17.0295C22.6439 16.1479 22.9207 15.2623 23.4103 14.7163C23.8452 14.2312 24.4176 14.0158 24.9499 14.0158V20.0158ZM20.9591 14.0158C21.4914 14.0158 22.0638 14.2312 22.4987 14.7163C22.9883 15.2623 23.2651 16.1479 22.9537 17.0295L17.2963 15.0311C16.8003 16.4352 17.2172 17.8136 18.0314 18.7217C18.791 19.5688 19.8727 20.0158 20.9591 20.0158V14.0158Z",
    fill: "#404040",
    mask: "url(#path-1-inside-1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4545 8.5C17.4545 11.9129 14.8962 14.5 11.9545 14.5C9.0127 14.5 6.45447 11.9129 6.45447 8.5C6.45447 5.08714 9.0127 2.5 11.9545 2.5C14.8962 2.5 17.4545 5.08714 17.4545 8.5Z",
    stroke: "#404040",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9545 20.8597C18.9545 20.6032 18.8573 20.355 18.674 20.1756C16.6876 18.2322 13.9689 17.0342 10.9705 17.0342C5.24188 17.0342 0.534579 21.4068 0.00412274 26.9965C-0.0482189 27.5481 0.404938 28 0.958968 28H17.9545C18.5068 28 18.9545 27.5523 18.9545 27V20.8597Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9705 20.0342C13.1534 20.0342 15.1275 20.9028 16.5759 22.32L20.772 18.0313C18.2478 15.5615 14.7845 14.0342 10.9705 14.0342V20.0342ZM2.9907 27.2799C3.3764 23.2157 6.80367 20.0342 10.9705 20.0342V14.0342C3.68009 14.0342 -2.30724 19.598 -2.98246 26.7131L2.9907 27.2799ZM17.9545 25H0.958968V31H17.9545V25ZM21.9545 27V20.8597H15.9545V27H21.9545ZM17.9545 31C20.1636 31 21.9545 29.2091 21.9545 27H15.9545C15.9545 25.8954 16.8499 25 17.9545 25V31ZM-2.98246 26.7131C-3.21894 29.205 -1.17853 31 0.958968 31V25C1.98841 25 3.1225 25.8912 2.9907 27.2799L-2.98246 26.7131ZM16.5759 22.32C16.142 21.8954 15.9545 21.3518 15.9545 20.8597H21.9545C21.9545 19.8546 21.5727 18.8146 20.772 18.0313L16.5759 22.32Z",
    fill: "#404040",
    mask: "url(#path-4-inside-2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4545 26.5V19.5H24.4545V26.5H21.4545Z",
    stroke: "#404040",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.4545,
    y: 11.5,
    width: 1,
    height: 1,
    stroke: "#404040",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9545,
    y: 11,
    width: 5,
    height: 2,
    transform: "rotate(90 12.9545 11)",
    fill: "#F1F0F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9545,
    width: 5,
    height: 2,
    transform: "rotate(90 12.9545 0)",
    fill: "#F1F0F0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.9545,
    y: 25,
    width: 7,
    height: 3,
    transform: "rotate(-180 19.9545 25)",
    fill: "#F1F0F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedArtists);
export default __webpack_public_path__ + "static/media/featured-artists.b59b59eb.svg";
export { ForwardRef as ReactComponent };